export default "__VITE_ASSET__DeFQiOcn__"